import type { ReactNode } from 'react';
import AdminSidebar from '../sidebar/AdminSidebar';

type AdminLayoutProps = {
  children: ReactNode;
};

export default function AdminLayout({ children }: AdminLayoutProps) {
  return (
    <div className="min-h-screen overflow-x-hidden bg-gray text-main">
      <div className="fixed top-0 left-0 h-screen w-[250px]">
        <AdminSidebar />
      </div>
      <main className="ml-[250px] box-border min-h-screen max-w-[calc(100vw-250px)] bg-white p-x3l">
        {children}
      </main>
    </div>
  );
}
